import type { CrawlJobMonitorDTO } from '../../types/lac';
import { useI18n } from '../../i18n/useI18n';
import { LacCrawlJobRow } from './LacCrawlJobRow';

export type LacWebsiteCrawlsJobListProps = {
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
  jobs: Array<CrawlJobMonitorDTO & { crawlJobId: string }>;
  hasActiveFilters: boolean;
  page: number;
  expandedJobIds: Set<string>;
  onToggleJobExpanded: (crawlJobId: string) => void;
  showTenant: boolean;
};

export function LacWebsiteCrawlsJobList({
  isLoading,
  isError,
  isFetching,
  jobs,
  hasActiveFilters,
  page,
  expandedJobIds,
  onToggleJobExpanded,
  showTenant,
}: LacWebsiteCrawlsJobListProps) {
  const { translate } = useI18n();

  if (isLoading && jobs.length === 0) {
    return (
      <p className="lac-website-crawls__status">
        {translate('lac.websiteCrawls.loading')}
      </p>
    );
  }

  if (isError && jobs.length === 0) {
    return (
      <p className="lac-website-crawls__status" role="alert">
        {translate('lac.websiteCrawls.loadError')}
      </p>
    );
  }

  if (jobs.length === 0) {
    const emptyMessage =
      hasActiveFilters || page > 1
        ? translate('lac.websiteCrawls.noResults')
        : translate('lac.websiteCrawls.empty');
    return <p className="lac-website-crawls__empty">{emptyMessage}</p>;
  }

  return (
    <ul
      className="lac-website-crawls__list"
      aria-label={translate('lac.tabs.websiteCrawls')}
      aria-busy={isFetching || undefined}
    >
      {jobs.map((job) => (
        <LacCrawlJobRow
          key={job.crawlJobId}
          job={job}
          isExpanded={expandedJobIds.has(job.crawlJobId)}
          onToggleExpanded={() => onToggleJobExpanded(job.crawlJobId)}
          showTenant={showTenant}
        />
      ))}
    </ul>
  );
}
